
















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import NewsModel from '@views/a-model/news-model';
import DefaultModel from '@views/a-model/default-model';
import EnumNewsType from '../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';
import NewsTranslation from '../../dataSource/api/RunPay/Admin/IServices/Models/News/NewsTranslation';
import ImagePreviewModel from 'crop-image/src/ImagePreviewModel';
import ObjectFabric from '../components/objectFabric';
import newsTranslation from '../a-model/news-ranslation';
import SaveNewsTranslation from '../../dataSource/api/RunPay/Admin/IServices/Models/SaveNewsTranslation';

@Component({
  name: 'news',
  components: {},
})
export default class NewsComponent extends Vue {
  langArr = ['en', 'ar', 'fr','ru'];
  defaultLang = 'fr';
  // langArr = [ 'ro', 'ru'];
  // defaultLang = 'ro';

  innerItems: NewsModel[] = [];

  pageSize = 13;
  currentPage = 1;
  totalItems = 0;

  modalWindowTitle = '';
  modalWindowShow = false;
  currentOperation = 'add';
  currentEditItemId = 0;

  editImage = false; // индиктор изменения картинки в режиме Edit

  addingNews: NewsModel = new NewsModel();

  search = '';

  fileZip: string = null;
  fileZipName = '';

  zipAlert = false;
  imageAlert = false;
  httpAlert = false;

  newsCategories = Array<ListViewItem<DefaultModel>>();
  isLoading = false;
  isLoadingModal = false;

  

  created() {
    document.title = this.$route.meta.title;
    const appsettings= require("../../../appsettings.json")
    const ProjectOptions = appsettings.ProjectOptions;
    this.langArr = ProjectOptions.langArr;
    this.defaultLang = ProjectOptions.defaultLang;
    this.getNewsCategory();
    this.getNews({ Take: this.pageSize, Skip: 0 });
  }

  isValid(): boolean {
    this.httpAlert = false;
    this.zipAlert = false;

    // if(!this.addingNews.folderName.startsWith("http")){
    //   this.httpAlert = true
    // }

    if (((this.fileZip == null && this.currentOperation != 'edit') || this.addingNews === undefined) && !this.addingNews.folderName.startsWith('http')) {
      this.zipAlert = true;
    }

    // if(this.imageCropArray==null){
    //   this.imageAlert = true;
    // }
    else this.imageAlert = false;
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid() && !this.zipAlert && !this.imageAlert && !this.httpAlert;
  }

  onChangeFolder() {
    this.httpAlert = false;
    // if(!this.addingNews.folderName.startsWith("http")){
    //   this.httpAlert = true
    // }
  }

  getNewsCategory() {
    this.newsCategories.push(new ListViewItem(new DefaultModel(0, 'Top'), true, false));
    this.newsCategories.push(new ListViewItem(new DefaultModel(1, 'Blog'), false, false));
    this.newsCategories.push(new ListViewItem(new DefaultModel(2, 'Pressa'), false, false));
  }

  getNews({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.NewsService.GetListEvent.once((response) => {
      this.isLoading = false;
      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage.toString());
        return;
      }
      
      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items.map((item) => ({
        id: item.Id,
        name: this.getDefaultName(item.Translations),
        translations: this.getTranslations(item.Translations, item.Id), // description: item.Description.toString(),
        dateCreate: item.DateCreate,
        folderName: item.FolderName.toString(),
        image: '',
        zipArchiveFile: '',
        type: item.Type,
      }));
    });

    this.isLoading = true;
    this.$api.NewsService.GetList({
      Search: this.search,
      Skip: Skip,
      Take: this.pageSize,
    });
  }

  getDefaultName(val: Array<NewsTranslation>): string {
    const currentLang = this.$locale.currentLang;
    let name=((val.find((el) => el.LangCode == currentLang)|| (val.find((el) => el.LangCode == this.defaultLang))||val[0]).Name ).toString()
    return name;
  }
  getTranslations(value: newsTranslation[], id: number): newsTranslation[] {
    value.forEach((item) => {
      item.Image = { Top: 0, Left: 0, Width: 0, Height: 0, ImageUrl: '' };
      item.Image.ImageUrl = this.getImage(id, item.LangCode.toString());
    });

    this.langArr.forEach((i) => {
      const finde = value.filter((item) => item.LangCode == i);

      if (finde.length == 0) {
        value.push({ LangCode: i, Name: '', Description: '', Image: { Top: 0, Left: 0, Width: 0, Height: 0, ImageUrl: '' } });
      }
    });
     value = value.filter((i)=>{
       const finde = this.langArr.filter((item) => item== i.LangCode);
       return finde.length != 0
     })
    return value;
  }
  onSearch() {
    this.getNews({ Take: this.pageSize, Skip: 0 });
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    
    this.currentPage = request.Page;
    this.getNews({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage,
    });
  }

  onDonloadZip() {
    (this.$refs.fileInputZip as any).click();
  }

  

  onChangedZip() {
    const file = (this.$refs.fileInputZip as any).files[0];
    this.fileZipName = file.name;
    this.getBase64(file).then(
      (res: string) => {
        this.fileZip = res;
      },
      (rej: string) => alert(rej)
    );
  }

  getBase64(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function() {
        resolve(reader.result.toString());
      };
      reader.onerror = function(error) {
        console.error('Error: ', error);
        reject(error);
      };
    });
  }

  onNewsAdd() {
    this.zipAlert = false;
    this.modalWindowTitle = this.$locale.getTranslate('ModalWindow_title_addNews');
    // this.initImageArray();
    this.currentOperation = 'add';
    this.addingNews = new NewsModel();
    this.addingNews.folderName = '';
    this.addingNews.translations = new Array<NewsTranslation>();
    this.langArr.forEach((i) => {
      this.addingNews.translations.push({ LangCode: i, Name: '', Description: '', Image: { Top: 0, Left: 0, Width: 0, Height: 0, ImageUrl: '' } });
    });
    this.modalWindowShow = true;
  }

  onNewsEdit(id: number) {
    this.zipAlert = false;
    this.modalWindowTitle = this.$locale.getTranslate('ModalWindow_title_editNews');
    this.currentOperation = 'edit';
    this.currentEditItemId = id;
    var itemNews = this.innerItems.filter((item) => item.id == id)[0];

    this.newsCategories.forEach((item) => (item.Selected = (item.Value as DefaultModel).id == itemNews.type));
    this.addingNews = itemNews;
    
    this.modalWindowShow = true;
  }

  onClickCloseZip() {
    this.fileZip = null;
  }

  closeModalWindow() {
    this.modalWindowShow = false;
    this.editImage = false;
    this.fileZip = null;
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case 'id':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case 'name':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }
      case 'category':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.type > b.type ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.type < b.type ? 1 : -1;
          });
          break;
        }
      case 'dateAdd':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.dateCreate > b.dateCreate ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.dateCreate < b.dateCreate ? 1 : -1;
          });
          break;
        }
      default:
        break;
    }
  }

  loading() {
    this.isLoading = true;
    this.innerItems = [];
  }

  async onDelete(newsId: string) {
    var res = await this.$dialog.confirm(this.$locale.getTranslate('Dialog_reallyDelete')).then((res: boolean) => {
      this.isLoading = false;
      if (res) {
        this.$api.NewsService.DeleteEvent.once((response) => {
          if (!response.IsSuccess) {
            this.$notification.error(response.ErrorMessage.toString());
            return;
          }
          this.getNews({ Take: this.pageSize, Skip: 0 });
        });
        this.loading();
        this.$api.NewsService.Delete(parseInt(newsId));
      }
      if (res == false) {
      }
    });
  }

  onOperation() {
    
    if (!this.isValid()) {
      this.$notification.error(this.$locale.getTranslate('Error filling in fields'))
      return;
    }

    this.$api.NewsService.SaveEvent.once((response) => {
      this.isLoadingModal = false;

      if (!response.IsSuccess) {
        
        this.$notification.error(response.ErrorMessage.toString());
        return;
      }
      this.closeModalWindow();
      this.innerItems = [];
      this.getNews({ Take: this.pageSize, Skip: 0});
    });
    

    this.addingNews.type = this.getNewsType(this.newsCategories.filter((item) => item.Selected)[0].Value.id);
    this.addingNews.zipArchiveFile = this.fileZip ? this.fileZip.substring(this.fileZip.indexOf(',') + 1) : null;
    this.isLoadingModal = true;
    let trans: SaveNewsTranslation[]=[];
    this.addingNews.translations.forEach(element=>{
      trans.push(new SaveNewsTranslation({LangCode:element.LangCode.toString(), Name:element.Name.toString(),
       Image:{Top:element.Image.Top,Left:element.Image.Left,Width:element.Image.Width,Height:element.Image.Height,ImageUrl:element.Image.ImageUrl},
       Description:element.Description.toString()}))
    })
    trans.forEach((element, index) => {
      if (element.Image.ImageUrl.substring(0, 1) == '/') trans[index].Image.ImageUrl = null;
    });
    // if (this.addingNews.translations[0].Image.ImageUrl.substring(0,1)=='/') this.addingNews.translations[0].Image.ImageUrl =null;
    // if (this.addingNews.translations[1].Image.ImageUrl.substring(0,1)=='/') this.addingNews.translations[1].Image.ImageUrl =null;
    // console.log("NewsService.Save до")

    this.$api.NewsService.Save({
      Id: this.addingNews.id,
      Translations:trans,
      FolderName: this.addingNews.folderName,
      Type: this.addingNews.type,
      ZipArchiveFile: this.addingNews.zipArchiveFile,
    });
    // console.log("NewsService.Save после")
    

  }

  getCurrentCategory(): DefaultModel {
    const category = this.newsCategories.filter((el) => el.Selected);
    return category.length > 0 ? (category[0].Value as DefaultModel) : null;
  }

  getNewsType(typeId: number): EnumNewsType {
    switch (typeId) {
      case 0:
        return EnumNewsType.Top;
        break;
      case 1:
        return EnumNewsType.Blog;
        break;
      case 2:
        return EnumNewsType.Pressa;
        break;
      default:
        break;
    }
  }

  getNewsTypeName(typeId: number): string {
    switch (typeId) {
      case 0:
        return 'Top';
        break;
      case 1:
        return 'Blog';
        break;
      case 2:
        return 'Pressa';
        break;
      default:
        break;
    }
  }

  getImage(id: number, langCode: string): string {
    return '/files/news/' + id + '_' + langCode + '.jpg';
  }

  onScroll(event: WheelEvent) {
    const target = this.$refs.scrollContainer as HTMLElement;
    const start = target.offsetTop;
    const childs = target.children;
    const currentScroll = target.scrollTop + event.deltaY;
    let currIndex = 0;
    for (currIndex = 0; currIndex < childs.length; currIndex++) {
      const el = childs[currIndex] as HTMLElement;
      const elStart = el.offsetTop - start;
      if (elStart <= currentScroll && elStart + el.clientHeight >= currentScroll) {
        break;
      }
    }
    const nextIndex = event.deltaY > 0 ? currIndex + 1 : currIndex;
    if (nextIndex < 0 || nextIndex >= childs.length) {
      return;
    }
    const nextEl = childs[nextIndex] as HTMLElement;
    target.scrollTop = nextEl.offsetTop - target.offsetTop;
    // this.scrollTo(target, nextEl.offsetTop - target.offsetTop);
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-news.vue